<div *ngIf="(online$ | async) === false" class="bf-offline-banner" role="alert" aria-live="assertive">
  <i class="fa fa-wifi" aria-hidden="true"></i>
  <span class="bf-offline-banner__text">{{ 'common.offline.message' | translate }}</span>
</div>
